<template>
    <div style="background: #00000029; z-index: 2; top: 0;" class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center w-100 h-100">
        <i class="fa-2x fas fa-circle-notch fa-spin"></i>
    </div>
</template>

<script>
    export default {
        name: 'Loading'
    }
</script>